// extracted by mini-css-extract-plugin
module.exports = {"garden":"garden","living":"living","wedding":"wedding","shadow":"compose-mail-dialog_shadow__1DHqA","form":"compose-mail-dialog_form__1tIMK"};